<div class="divider divider-horizontal">This is a header</div>
